<template>
  <div class="registration-finished">
    <div class="registration-finished-message-area">
      <div class="registration-finished-message verify-text">
        {{ $t('registration.finished') }}
      </div>
      <v-btn class="registration-close-button" color="primary" @click="onClose">{{ $t('close') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { views } from '@/router/constants';
import { CLEAN_SP_COMPANY_REGISTRATION_DATA } from '@/store/spCompanyRegistration/actionTypes';

export default {
  name: 'SPCompanyRegistrationFinished',
  methods: {
    async onClose() {
      await this.$store.dispatch(CLEAN_SP_COMPANY_REGISTRATION_DATA);
      await this.$router.push({ name: views.SIGN_IN });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.registration-finished {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;

  .registration-finished-message-area {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    max-width: rem(355);
    min-width: rem(200);
    padding: rem(32) rem(29);
    border-radius: $radius-sm;
    background-color: $white;
    box-shadow: 0 0 rem(4) 0 rgba(14, 31, 51, 0.13);

    .registration-close-button {
      margin: 0 rem(100);
    }

    .registration-finished-message {
      padding: 0 rem(30);
      margin-bottom: rem(40);
      text-align: center;
      color: $auth-text-primary;
      font-size: rem(16);
      letter-spacing: 0;
      line-height: rem(24);
      text-align: center;
    }
  }
}
</style>
